import axios from 'axios';

import settings from '../libs/config';
import ApiError from './apiError.js';

const endpointError = settings.api_host + "/notify/error";

export const createErrorNotification = async (data, user_token) => {
	if (!data) throw new Error("Missing notification data");
	if (!user_token) throw new Error("Missing User Token");

	let params = {
		user_token: user_token,
		group_id: data.group_id,
		panel_segment: data.panel_segment,
		user_id: data.user_id,
		error: data.error ? data.error : "n/a",
		source: data.source ? data.source : "n/a",
		code: data.code ? data.code : "n/a",
		type: data.type ? data.type : "n/a",
		message: data.message ? data.message : "n/a",
		timecode: (data.timecode || data.timecode === 0) ? data.timecode : "n/a",
		player_state : data.player_state,
		player_resumed : data.player_resumed,
		video_duration : data.video_duration,
		panel_ready: data.panel_ready,
		survey_status : data.survey_status, // active or inactive
		survey_type : data.survey_type, // preroll, invideo, postroll
		survey_qid : data.survey_qid, // last question seen
		survey_aid : data.survey_aid, // last answer submitted	
		browser: data.browser ? data.browser : "n/a",
		os: data.os ? data.os : "n/a",
		platform: data.platform ? data.platform : "n/a",
		uagent: data.uagent ? data.uagent : "n/a",
		playerInfo: data.playerInfo ? data.playerInfo : "n/a",
		osName: data.osName ? data.osName : "n/a",
		browserName: data.browserName ? data.browserName : "n/a",
	};

	try {
		const response = await axios({
			method: 'post',
			url: endpointError,
			data: params,
			config: { headers: { 'Content-Type': 'multipart/form-data' } }
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};


// WEBPACK FOOTER //
// ./src/api/notify.js